<template>
  <div class="content">

    <c수임액신고서_도움말 ref="help"/>

		<s-location apply title="수임사건 신고"/>

    <!--  주의사항  -->
    <div class="comment dot_gray bg_gray  expcomment mtb30">
      <p class="tit"> 수임액 신고란?</p>
      <li>회원은 변호사법 제28조의2(수임사건의 건수 및 수임액의 보고)에 따라 매년 1월 말까지 전년도에 처리한 수임사건의 건수와 수임액을 본회에 신고하여야 합니다.</li>

      <p class="tit"> 신고 전 알아두어야 할 사항</p>
      <li>법무법인, 법무법인(유한), 공동법률사무소(대한변협에 신고한)는 마스터 계정으로 신고해야하며, 이 경우에는 해당 사무소에 소속된 변호사 모두가 신고한 것으로 처리됩니다.</li>
      <p class="sub01 red01">① 소속변호사가 개별로 신고할 필요 없음</p>
      <p class="sub01 red01">② 분사무소의 경우 원칙은 주사무소에서 합산 신고하되, 분사무소만 별도로 신고를 원할 경우 마스터 계정으로 별도 신고 가능합니다.</p>


      <li>타 지방회가 주사무소인 법무법인, 법무법인(유한)의 분사무소인 경우 마스터 계정 생성이 불가하기 때문에 분사무소의 대표변호사 계정으로 로그인하여 신고해야하며, 이 경우에는 분사무소에 소속된 변호사 모두를 공동신고인으로 추가하여 신고합니다.</li>
      <p class="sub01 red01">① 소속변호사가 개별로 신고할 필요 없음</p>
      <p class="sub01 red01">② 다만, 분사무소의 내부사정상 회원별 신고를 해야 할 경우 회원의 각 계정으로 로그인 하여 개별신고 가능합니다.</p>

      <li>개인법률 사무소, 사내변호사, 대한변호사협회에 신고되지 않은 공동법률사무소의 경우에는 개인회원 계정으로 로그인하여 신고합니다.</li>
      <p class="sub01 red01 ">① 고용변호사 등 공동신고를 원하는 변호사가 있으면 공동신고인으로 추가해서 신고 가능합니다.</p>


      <div class="box tip">
        <div class="tit mb20 ft16">[ Tip ]</div>
          <li>공동신고인의 경우 [연도별 수임사건 신고현황]에서 신고여부를 확인할 수 있으며 신고 내역은 대표신고인만 조회할 수 있습니다.</li>
          <li>수임신고는 <span class="red01"> 귀속 수임연도(1년간)에 수임한 모든 사건을 신고해야 합니다.</span> 법무법인 등에 소속되기 전, 또는 탈퇴 후에 개인으로 수임한 사건이 있을 경우 [추가 신고하기]를 통해 별도 신고해야 합니다.</li>
          <li>수임한 사건이 없거나, 수임액이 없는 회원의 경우에도(예. 사내변호사 등) 반드시 매년 1월 말까지 수임액 신고를 해야 하며 이런 경우에는 신고하기에서 [무수임신고]를 통해 간단히 신고할 수 있습니다.</li>
          <li>관련법에 따라 해당 귀속수임연도의 수임 사건을 다음연도 1월 말까지 신고하는 것이 원칙이지만, 신고기간이 지났다고 하더라도 회원이 신고를 원할 경우 해당 귀속수임연도를 선택 후 신고할 수 있습니다.
            <span class="red01"> (단, 신고기간이 지난 후에 제출한 건은 수정/삭제할 수 없습니다)</span></li>
          <li>해당 귀속수임사건의 신고기한(1.1.~ 1.31.) 중에는 제출 후 수정/삭제가 가능하지만, 신고기한이 지난 건은 제출만 가능하고, 수정/삭제할 수 없습니다.</li>
      </div>



    </div>

    <!-- ------------------------------------------------------------------------------------------------------------------------------------ -->
    <!-- 목록 -->
    <!-- ------------------------------------------------------------------------------------------------------------------------------------ -->
      <div class="sub_title02_wrap">

        <h4 class=" sub_title02">연도별 수임사건 신고현황</h4>
        <div class="sub_wrap">
          신고연도
          <select v-model="selYear" @change="doChangeYear()"
            style="border-color: #333333; height: 30px; padding: 0 15px 0 10px; font-weight: bold;">
            <option v-for="item in reptyy_list" :value="item.REPTYY" :key="item.REPTYY">{{item.REPTYY}}년</option>
          </select>
          <a v-if="selYear" @click="report_popup({REPTYY: selYear}, 'add')" class="btn xs org01  ml10"
          v-tooltip.top="yearMessage"
          >
            {{ sitem.CNT_ALL > 0 ? '추가 신고하기' : '신고하기'}}
          </a>
          <!-- <template v-if="sitem && sitem.CNT_ALL > 0">
            ( 내가 {{ sitem.CNT_MY }} 건 신고
              <template v-if="sitem.CNT_OTHER > 0">
              , 다른 사람이 {{ sitem.CNT_OTHER }} 건 신고, 총 {{ sitem.CNT_ALL }} 건 신고
              </template>
            )
          </template> -->
          <!-- {{ sitem }} -->
        </div>
      </div>

    <div class="scroll_wrap w600 relate"> <!--모바일 스크롤 -->
      <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>
      <table class="tbl01">
        <tr>
          <th class="viakind">귀속수임연도</th>
          <th>수임기간</th>
          <th class="viakind">신고여부</th>
          <th class="day">신고일</th>
          <th class="vianame">신고인</th>
          <th>사무실 형태</th>
          <th>사무실명</th>
          <th>공동신고인</th>
          <th class="viakind">비고</th>
        </tr>
        <tr v-for="(item,i) in list.list" :key=i :style="{
          'background-color': item.REPSEQ && item.REPTYY == selYear ? '#FFFFF0' : 'white'
        }">
          <td>{{ item.REPTYY }}</td>
          <td>{{ item.REPTYY }}.01.01 ~ {{ item.REPTYY }}.12.31</td>
          <td class="viakind"><font class="red01">{{ item.REPTYNNM }}</font></td><!-- 해당연도에 따라 제출여부 판단 -->
          <td>{{ item.INCMGDT | moment('YYYY.MM.DD') }}</td><!-- 신고일 -->
          <td><!-- 신고인 -->
            <!-- 미제출인 경우 신고인 표기 안함 -->
            <span v-if="item.REPTYNNM != '미제출'">{{ item.CREATE_MEMBNM }}({{ item.CREATE_MEMBNO }})</span>
          </td>
          <td>{{ item.OFFICEKIND == 'etc' ? item.OFFICEKIND_ETC : item.OFFICEKIND }}</td>
          <td>
              {{ item.OFFICENM }}
              <template v-if="item.OFFICEKIND == '분사무소'">
                {{ item.OFFICEKIND_ETC }}
              </template>
          </td>
          <td>

              <template v-if="item.REPSEQ"> <!-- 신고된게 있을때 -->
                <template v-if="item.MEMBCLSF != 'P'"><!-- 단체신고일때 -->
                  {{ item.MEMBNM }}({{ item.MEMBNO }})<!-- 단체명(번호) -->
                </template>
                <template v-else><!-- 개인신고일때 -->

                  <!-- 남이 신고한것일때 -->
                  <template v-if="item.CREATE_MEMBNO != null && !(item.CREATE_MEMBNO == $store.state.session.user.membno.trim() && item.CREATE_MEMBCLSF == $store.state.session.user.membclsf.trim())">
                    {{ item.MEMBNM }}({{ item.MEMBNO }}) <!-- 내이름표시 -->
                  </template>
                  <template v-else>
                    {{ item.CNT_MEMBNM }}({{ item.CNT_MEMBNO }}) <!-- 신고자 -->
                  </template>

                  <template v-if="item.CNT_MEMB_OTHER_CNT">
                    외 {{ item.CNT_MEMB_OTHER_CNT }}명
                  </template>

                </template>
              </template>
          </td>
          <td class="viakind"><!-- 제출여부 -->
            <!-- 제출했을 경우에만 -->

            <!-- <a v-if="item.REPTYNNM == '제출' || item.REPTYNNM == '제출(무수임)'"
              href="#show"
              @click="view(item)"
              class="btn xs gray01 outline">{{ item.기간여부 == '기간내' ? '수정' : '내역보기' }}</a> -->

            <!-- <a v-else-if="item.기간여부 != '기간전'"
              href="#show"
              @click="newItem(item.REPTYY)"
              class="btn xs gray01">신규작성</a> -->

            <!-- {{ item.기간여부 }} -->
            <template v-if="item.CREATE_MEMBNO == null || (item.CREATE_MEMBNO == $store.state.session.user.membno.trim() && item.CREATE_MEMBCLSF == $store.state.session.user.membclsf.trim())">

              <template v-if="item.REPTYNNM == '제출' || item.REPTYNNM == '제출(무수임)'">
                <a @click="report_popup(item, 'edit')" class="btn xs gray01 outline">내역보기</a>
                <!-- <a @click="report_popup(item, 'add')" class="btn xs gray01 outline">추가 신고하기</a> -->
              </template>
              <template v-else>
                <!-- <a @click="report_popup(item, 'add')" class="btn xs gray01 outline">신고하기</a> -->
              </template>
            </template>
            <template v-else>
              <!-- <a @click="report_popup(item, 'add')" class="btn xs gray01 outline">신고하기</a> -->
            </template>

          </td>
        </tr>
      </table>
     </div> <!--// scroll_wrap -->

</div> <!-- content : width=950px; -->
</template>

<script>
let ui
export default {
    components: {
      'c수임액신고서_도움말' : require('./c수임액신고서_도움말.vue').default,
    },
  // beforeRouteEnter (to, from, next) {
  //   T.httpGet("/return_req/reptyy_list", {},
  //       ret=> {
  //         next(vm => {
  //           vm.reptyy_list = ret.data.list
  //         })
  //       }
  //     )
    // next(vm => {
    //   vm.$ui.httpGet("/return_req/reptyy_list", {},
    //     ret=> {
    //       console.log("ret =", ret.data.list);
    //       vm.reptyy_list = ret.data.list
    //       // vm.$set('reptyy_list', ret.data.list)
    //     }
    //   )
    // })
  // },
  data() {
    return {
      selYear: '',
      sitem: {},
      list: {}, // 신고현황 리스트
      reptyy_list: [], // 귀속수임년도 select box용 [ REPTYY, ]
      comment_show: false, // 도움말
    }
  },
  computed: {
    yearMessage() { // https://hekigan.github.io/vue-directive-tooltip/#/globals
      let sitem = this.sitem
      if (!sitem || sitem.CNT_ALL < 1 ) return "신고서 작성하기"
      return sitem.CNT_OTHER > 0
        ? `내가 ${ sitem.CNT_MY } 건, 다른 회원이 ${ sitem.CNT_OTHER } 건, 총 ${ sitem.CNT_ALL } 건 신고함`
        : `${ sitem.CNT_MY } 건 신고함`
    },
  },
  watch : {
    '$route': 'initData',
  },
  created() {
    ui = this.$ui;
  },
  mounted() {
    ui.httpGet("/return_req/reptyy_list", {}, ret => this.reptyy_list = ret.data.list )
    this.initData()
  },
  methods: {
    initData(){ // 현재 메뉴 다시 클릭 시

      // this.selYear = this.$moment().subtract(1, 'years').format('YYYY')

      const month = this.T.toInt(this.$moment().format('MM')) // 이번달 int

        if (month !== 12)  { // 1~11월일떄 1년 빼기
        this.selYear = this.$moment().subtract(1, 'years').format('YYYY')
      } else {
        this.selYear = this.$moment().format('YYYY')
      }



      this.doChangeYear()
      this.getData()
    },
    newItem(year) { // 지정년도 신규등록
      this.sitem = { REPTYY: year }
      this.getData()
    },
    doSearch() {
      this.list.pageNo = 1
      this.getData()
    },
    getData() { // 기본 데이터 조회
      ui.httpGet("/return_req/list"     , _.omit(this.list , ['list'])  , ret => this.list  = ret.data ) // 목록조회
    },
    doChangeYear() { // 년도를 변경한 경우
      // sitem 조회하여 기관관련 정보 설정 ( 속도 : 빠름 )
      this.sitem = {}
      if (this.selYear) {
        ui.httpGet("/return_req/get_sitem", {REPTYY: this.selYear},
          ret => this.sitem = ret.data.sitem)
      }
    },

    /* 신고하기 */
    report_popup(item, mode) {
      this.$modal.show(require('./c수임액신고서.vue').default, { // https://www.npmjs.com/package/vue-js-modal
        item : _.pick(item, ['REPTYY', 'REPSEQ']),
        mode, // add, edit
        parentReload : v=> { this.doSearch(); this.doChangeYear() },
        comment_show : v=> this.$refs.help.show()
        // cb_agree : () => { opt.resolve(true) ; modal.hide(modalName) }, // 확인 클릭
        // cb_cancel: () => { opt.resolve(false); modal.hide(modalName) }, // 취소 클릭
      }, {
        // 모달 속성
        name: "c수임액신고서",
        height: 'auto',
        // height: 730,
        // height: '100%',
        scrollable: true, // height: auto 하고 scrollable:true 는 한세트
        width: 960,
        // width: '100%',
        // draggable: true,
        draggable: ".window-header",
        resizable: true,
        adaptive: true,
        pivotY: 0.3,
        reset: true,
        clickToClose: false,
      }, {
        'before-close':  v=> this.$refs.help.hide(), // 이거 닫힐때 도움말도 같이 닫는다.
        // 이벤트
        // 'before-close': (e,v) => { console.log('모달을 닫는다1. event =', e); console.log('모달을 닫는다2. event =', v);  },
        // 'closed': (e,v) => { console.log('모달3 CLOSED =', e); console.log('모달4 CLOSED =', v); },
      })
    },


  },
}
</script>
<style scoped>
.gubun .tit { margin: 0; }
.gubun .tit:nth-child(n+2) { margin-top: 25px; } /* 두번째 .tit 부터 탑 마진 적용 */

@media screen and (max-width:640px){
  .scroll_wrap { padding:0;}
  .scroll_wrap .scroll_txt { position: relative; margin-top:0; margin-bottom:0; background: none;};

}
</style>